export default {
  lightBlue: 'light-blue',
  transparent: 'transparent',
};
